import React, { useCallback, useEffect, useState } from "react";
import "../assets/css/mainpage.css";
import Table from "../components/table/Table";

import Alert from "../components/alert";
import { useHistory } from "react-router-dom";

import config from "../api/config";

import { Button } from "@mui/material";
// table data
const headData = ["Наименование", "Категория", "Статус",];
const renderHead = (item, index) => <th key={index}>{item}</th>;
//
// starting component
const Confirmation = () => {
  const [url] = useState("/api/advertising/v1");
  const [, setTotal] = useState(0);
  const [, setCurrPage] = useState(0);

  const [loading, setLoading] = useState(false);
  const [ads, setAds] = useState(null);

  const [role] = useState(0);
  const navigate = useHistory();

  // rolechanger

  const getAllPosts = useCallback(() => {
    setLoading(true);
    config
      .get(`${url}?isSent=${role === 0 ? false : true}`)
      .then((data) => {
        setLoading(false);
        setAds(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => console.error(err?.message));
  }, [role, url]);
  useEffect(() => {
    getAllPosts();
  }, [getAllPosts]);

  // menu data
  const renderBody = (item, index) => (
    <tr key={index}>
      <td>{item.name}</td>
      <td> {item.category ? item.category.nameRu : "User type"} </td>{" "}

      <td>
        <Alert severity={item?.isSent ? "success" : "error"} className="my-3">
          {item?.isSent ? "Подтверждено" : "Не подтверждено"}
        </Alert>
      </td>
      <td>
        <Button
          onClick={() =>
            navigate.push({
              pathname: `/sendpost`,
              data: item,
            })
          }
          variant="outlined"
          // startIcon={<ArrowBackIosNewIcon />}
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Посмотреть
        </Button>
      </td>
    </tr>
  );

  return (
    <div className="">
      <div className="row py-3">
        {/* <div className="col-md-6 col-sm-12">
          <input type="text" value={search} onChange={searchHandler} />
        </div> */}
        <div className="col-md-6 col-sm-12 col-md-offset-2">
          {/* <CustomSelect
            selVal={role}
            selItems={roles}
            type={"outlined"}
            selHandle={(e) => {
              roleHandler(e);
              console.log(e);
            }}
          /> */}
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {ads != null ? (
            ads.length > 0 ? (
              <Table
                headData={headData}
                renderHead={(item, index) => renderHead(item, index)}
                bodyData={ads}
                renderBody={(item, index) => renderBody(item, index)}
                // pages={total}
                // currPage={currpage}
                // changePage={pageHandler}
                loading={loading}
              />
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
